import _ from 'lodash'
import Vue from 'vue'

const state = {
  channels: {}
}

const getters = {
  channels: state => state.channels,

  channel: (state) => (channelName) => {
    return state.channels.hasOwnProperty(channelName) ? state.channels[channelName] : null
  },
  loading: (state) => (channelName) => {
    return state.channels.hasOwnProperty(channelName) ? !!state.channels[channelName].loading : null
  },
  errors: (state) => (channelName) => {
    return state.channels.hasOwnProperty(channelName) ? !!state.channels[channelName].errors : null
  },
  me: (state) => (channelName) => {
    if (state.channels.hasOwnProperty(channelName)) {
      return state.channels[channelName].me
    }

    return {}
  },
  members: (state) => (channelName) => {
    if (state.channels.hasOwnProperty(channelName)) {
      return state.channels[channelName].members
    }

    return []
  },
  membersCount: (state) => (channelName) => {
    if (state.channels.hasOwnProperty(channelName)) {
      return state.channels[channelName].members.length
    }

    return 0
  },
  owner: (state) => (channelName) => {
    if (state.channels.hasOwnProperty(channelName)) {
      if (state.channels[channelName].members && state.channels[channelName].members.length) {
        return state.channels[channelName].members[0]
      }
    }

    return {}
  },
  isOwner: (state) => (channelName) => {
    if (process.env.VUE_APP_AVANTI_ENV === 'local' || process.env.VUE_APP_AVANTI_ENV === 'staging') {
      return true
    }

    if (state.channels.hasOwnProperty(channelName)) {
      if (state.channels[channelName].members && state.channels[channelName].members.length && state.channels[channelName].me) {
        if (state.channels[channelName].me.id === state.channels[channelName].members[0].id) {
          return true
        }

        return false
      }
    }

    return null
  }
}

const actions = {
  subscribe: ({commit, displatch}, channelName) => {
    return new Promise((resolve, reject) => {
      if (state.channels.hasOwnProperty(channelName)) {
        return reject(new Error('Presence::subscribe: Already subscribed to this channel: ' + channelName))
      }

      commit('subscribe', channelName)
      resolve()
    })
  },
  unsubscribe: ({commit, displatch}, channelName) => {
    return new Promise((resolve, reject) => {
      if (!state.channels.hasOwnProperty(channelName)) {
        return resolve()
      }

      commit('unsubscribe', channelName)
      resolve()
    })
  },
  subscription_succeeded: ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      if (!state.channels.hasOwnProperty(payload.channelName)) {
        return reject(new Error('Presence::subscription_succeeded: No channel named: ' + payload.channelName))
      }

      commit('subscription_succeeded', payload)
      resolve()
    })
  },
  subscription_error: ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      if (!state.channels.hasOwnProperty(payload.channelName)) {
        return resolve()
      }

      commit('subscription_error', payload)
      resolve()
    })
  },
  member_added: ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      if (!state.channels.hasOwnProperty(payload.channelName)) {
        return reject(new Error('Presence::member_added: No channel named: ' + payload.channelName))
      }

      commit('member_added', payload)
      resolve()
    })
  },
  member_removed: ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      if (!state.channels.hasOwnProperty(payload.channelName)) {
        return reject(new Error('Presence::member_removed: No channel named: ' + payload.channelName))
      }

      commit('member_removed', payload)
      resolve()
    })
  }
}

const mutations = {
  'subscribe': (state, channelName) => {
    Vue.set(state.channels, channelName, { me: {}, members: [], loading: true, errors: false })
  },
  'unsubscribe': (state, channelName) => {
    Vue.delete(state.channels, channelName)
  },
  'subscription_succeeded': (state, payload) => {
    const data = {
      me: payload.members.me,
      members: [],
      loading: false,
      errors: false
    }

    payload.members.each(function (member) {
      data.members.push(member)
    })
    data.members = _.orderBy(data.members, 'info.time', 'asc')

    Vue.set(state.channels, payload.channelName, data)
  },
  'subscription_error': (state, payload) => {
    const data = {
      me: {},
      members: [],
      loading: false,
      errors: true
    }

    Vue.set(state.channels, payload.channelName, data)
  },
  'member_added': (state, payload) => {
    const current = state.channels[payload.channelName]

    current.members.push(payload.member)
    current.members = _.orderBy(current.members, 'info.time', 'asc')

    Vue.set(state.channels, payload.channelName, current)
  },
  'member_removed': (state, payload) => {
    const current = state.channels[payload.channelName]
    const index = current.members.findIndex(x => x.id === payload.member.id)

    if (index !== -1) {
      current.members.splice(index, 1)

      Vue.set(state.channels, payload.channelName, current)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/presence.js